import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { AppData } from '../../types';
import { formatDateTime } from '../../utils/dateFormat';
interface TimelineTabProps {
  data: AppData;
}
export function TimelineTab({
  data
}: TimelineTabProps) {
  const [filter, setFilter] = useState('All');
  const allEvents = [...data.incidents.map(i => ({
    ...i,
    type: 'Incident'
  })), ...data.checkins.map(c => ({
    ...c,
    type: 'Check-in',
    title: `Mood: ${c.mood}`,
    description: c.notes
  })), ...data.evidence.map(e => ({
    ...e,
    type: 'Evidence',
    title: e.fileName,
    description: e.description
  }))].sort((a, b) => {
    const dateA = 'datetime' in a ? a.datetime : 'timestamp' in a ? a.timestamp : '';
    const dateB = 'datetime' in b ? b.datetime : 'timestamp' in b ? b.timestamp : '';
    return new Date(dateB).getTime() - new Date(dateA).getTime();
  });
  const filteredEvents = filter === 'All' ? allEvents : allEvents.filter(e => e.type === filter.replace('s Only', ''));
  return <div className="max-w-4xl mx-auto" data-id="element-339">
      <div className="flex justify-between items-center mb-8" data-id="element-340">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-341">Case Timeline</h2>
        <select className="px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-purple bg-white" value={filter} onChange={e => setFilter(e.target.value)} data-id="element-342">
          <option value="All" data-id="element-343">All Events</option>
          <option value="Incidents Only" data-id="element-344">Incidents Only</option>
          <option value="Check-ins Only" data-id="element-345">Check-ins Only</option>
          <option value="Evidence Only" data-id="element-346">Evidence Only</option>
        </select>
      </div>

      <div className="relative border-l-2 border-gray-200 ml-4 space-y-8 pb-8" data-id="element-347">
        {filteredEvents.length === 0 ? <div className="pl-8 text-gray-500" data-id="element-348">No timeline events found.</div> : filteredEvents.map((event: any) => {
        const date = 'datetime' in event ? event.datetime : event.timestamp;
        return <div key={`${event.type}-${event.id}`} className="relative pl-8" data-id="element-349">
                <div className={`absolute -left-[9px] top-0 w-4 h-4 rounded-full border-2 border-white shadow-sm
                  ${event.type === 'Incident' ? 'bg-red-500' : event.type === 'Evidence' ? 'bg-blue-500' : 'bg-purple-500'}`} data-id="element-350" />

                <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2" data-id="element-351">
                  <span className="text-sm font-bold text-primary-purple font-mono" data-id="element-352">
                    {formatDateTime(date)}
                  </span>
                  <Badge variant={event.type === 'Incident' ? 'red' : event.type === 'Evidence' ? 'blue' : 'purple'} data-id="element-353">
                    {event.type}
                  </Badge>
                </div>

                <Card className="mb-2" data-id="element-354">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-355">
                    {event.title}
                  </h3>
                  {event.description && <p className="text-gray-600 text-sm" data-id="element-356">{event.description}</p>}
                  {event.type === 'Check-in' && <div className="mt-2 text-sm text-gray-500" data-id="element-357">
                      {event.symptoms && <p data-id="element-358">Symptoms: {event.symptoms}</p>}
                      {event.emotionalImpact && <p data-id="element-359">Impact: {event.emotionalImpact}</p>}
                    </div>}
                </Card>
              </div>;
      })}
      </div>
    </div>;
}